import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

function BaseLayout({ children, restaurant, loading  }) {
  return (
    <div>
      <header>
      <div className="container-fluid">
        <div className="row py-3 border-bottom">
          
          <div className="col-sm-4 col-lg-3 text-center text-sm-start">
            <div className="main-logo">
              <a href="">
                {restaurant?.logo && (
                  <img
                    src={`${process.env.REACT_APP_STORAGE_URL}${restaurant.logo}`}
                    alt={restaurant.name} className="img-fluid"
                  />
                )}
              </a>
            </div>
          </div>
          <div className="d-none">
            <h6 className="mb-0">
              {restaurant?.name || "Restaurant"}
            </h6>
            <small className="text-muted">
              {restaurant?.address || ""}
            </small>
          </div>
          

        </div>
      </div>
      
    </header>

      <div >
        
        <div style={{flex:1,padding:"0px"}}>
          {loading ? (
            
            
          <div className="text-center p-5">Loading...</div>
          
        ) : (
          children
        )}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default BaseLayout;